<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>
        <router-link :to="{name:'企業沿革'}"><span>企業沿革</span></router-link>
      </div>

      <h2 class="titleA">企業沿革</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'公司簡介'}" class="menu_on0">關於白金</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2279','http://www.ptotinc.com/','0','','2280')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2279"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'公司簡介'}" class="menu_on0">公司簡介</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'經營理念'}" class="menu_on0">經營理念</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'核心競爭力'}" class="menu_on0">核心競爭力</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業沿革'}" class="menu_on2">企業沿革</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業社會責任'}" class="menu_on0">企業社會責任</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'產業新聞'}" class="menu_on0">產業新聞</router-link>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">
          <form
            method="POST"
            action="portal_c2_cnt.php?owner_num=c2_38424&amp;button_num=c2&amp;folder_id=2280&amp;search_type=1"
          >
            <div class="searchbar">
              <ul>
                <li>
                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input
                    tabindex="63"
                    name="search_word"
                    type="text"
                    class="input"
                    value=""
                  />
                  <input
                    tabindex="64"
                    name="search_b1"
                    type="submit"
                    class="btn"
                    value="查詢"
                  />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38424&button_num=c2&folder_id=2280&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

<div class="cate_info">     <span style="font-size: 15px;"><strong><span style="font-size: 18px;">企業沿革</span></strong><br>
<br>
大事記<br>
2005&nbsp;&nbsp; 首款吸收式色彩補正玻璃(藍玻璃)開發完成.<br>
2006&nbsp;&nbsp; 第一條玻璃熔煉線設立完成,並開始量產.<br>
2007&nbsp;&nbsp; 全製程產線於台北工廠設立完成,正式導入一貫化生產.<br>
2007&nbsp;&nbsp; 針對手機用攝像頭設計的藍玻璃開發完成並量產.<br>
2008&nbsp;&nbsp; 挑戰開發Vℷ ”人類視覺模擬玻璃”,並完成量產準備.<br>
2009&nbsp;&nbsp; 色彩補正玻璃(藍玻璃)開始出貨給韓系及日系5M/8M/12M像素手機.<br>
2009&nbsp;&nbsp; Vℷ ”人類視覺模擬玻璃”開始出貨.<br>
2010&nbsp;&nbsp; 厚度0.21mm色彩補正玻璃開發完成並導入量產,出貨.<br>
2011&nbsp;&nbsp; 開始出貨給美系客戶,正式進入歐美市場.<br>
2011&nbsp;&nbsp; 獲ISO-9001:2008認證.<br>
2012&nbsp;&nbsp; 獲ISO-14001:2004認證.<br>
2012&nbsp;&nbsp; 厚度0.15 mm 及0.175mm色彩補正玻璃開發完成.<br>
2012&nbsp;&nbsp; 開始投入大陸市場並開始服務大陸客戶.<br>
2013&nbsp;&nbsp; 厚度0.15 mm 及0.175mm色彩補正玻璃開始出貨.<br>
2014&nbsp;&nbsp; 桃園工廠完工,產線搬遷完成,量產.<br>
2014&nbsp;&nbsp; 獲GP綠色夥伴及CSR企業社會責任認證.<br>
2015&nbsp;&nbsp; 連續式熔煉線擴增至三條.<br>
2015&nbsp;&nbsp; 獲OHSAS-18001:2007及SA-8000:2008認證<br>
2016&nbsp;&nbsp; 連續式熔煉線擴增至四條, 日總產能達2.4M pcs 75mm x 40mm中片.</span> </div>

          <ul id="c_list"></ul>

          <br /><br />
          <p style="text-align: center"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'milestone',
  // mixins: [sliderPro],
  data () {
    return {
      msg: 'Milestone'
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    // sliderPro.m1()
    // sliderProAddTitle('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
    // sliderPro.initialSliderPro()
    // sliderPro.m1('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/about/Milestone.vue